const GameRecordAllComponent = () => import('@/views/query/GameRecord/GameRecordAll/GameRecordAllView')

export default [
    {
        path:'/GameRecordAllIndex',
        name:'GameRecordAllRouter',
        component:GameRecordAllComponent
    }
]